export default function CorpsMetier() {
  const trades = [
    {
      icon: 'ri-hammer-line',
      title: 'Maçonnerie',
      description: 'Gros œuvre, démolitions, murs porteurs, dalles et fondations. Travaux structurels et de consolidation.',
      color: 'orange'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Peinture',
      description: 'Peinture intérieure et extérieure, revêtements muraux, finitions décoratives et protection des surfaces.',
      color: 'orange'
    },
    {
      icon: 'ri-door-line',
      title: 'Menuiserie',
      description: 'Portes, fenêtres, parquets, escaliers, agencements sur mesure et travaux de charpente.',
      color: 'orange'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Carrelage',
      description: 'Pose de carrelage, faïence, mosaïque, pierres naturelles pour sols et murs intérieurs et extérieurs.',
      color: 'orange'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Électricité',
      description: 'Installations électriques complètes, tableaux, éclairage, prises, conformité OIBT/NIBT et domotique.',
      color: 'teal'
    },
    {
      icon: 'ri-drop-line',
      title: 'Sanitaire',
      description: 'Plomberie, évacuations, alimentation en eau, salles de bains, cuisines et installations sanitaires.',
      color: 'teal'
    },
    {
      icon: 'ri-fire-line',
      title: 'Chauffage',
      description: 'Pompes à chaleur, radiateurs, chauffage au sol, chaudières et systèmes de régulation thermique.',
      color: 'teal'
    },
    {
      icon: 'ri-wind-line',
      title: 'Ventilation',
      description: 'VMC double flux, ventilation mécanique, extraction d\'air et systèmes de renouvellement d\'air.',
      color: 'teal'
    },
    {
      icon: 'ri-home-wifi-line',
      title: 'Domotique',
      description: 'Automatisation, contrôle intelligent, gestion énergétique et systèmes de sécurité connectés.',
      color: 'teal'
    },
    {
      icon: 'ri-landscape-line',
      title: 'Aménagement Extérieur',
      description: 'Terrasses, allées, clôtures, jardins et espaces extérieurs avec coordination paysagiste.',
      color: 'orange'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Isolation',
      description: 'Isolation thermique et phonique, façades, toitures, sols et amélioration de la performance énergétique.',
      color: 'orange'
    },
    {
      icon: 'ri-tools-line',
      title: 'Métallerie',
      description: 'Garde-corps, portails, structures métalliques, serrurerie et ouvrages en acier ou aluminium.',
      color: 'orange'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Corps de Métier</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Tous les Métiers du Bâtiment
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            En tant qu'entreprise générale, nous coordonnons l'ensemble des corps de métier nécessaires à la réalisation de votre projet.
          </p>
        </div>

        <div className="mb-12 flex items-center justify-center gap-8">
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 bg-teal-600 rounded"></div>
            <span className="text-sm font-semibold text-gray-700">Notre Expertise CVSE</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 bg-orange-600 rounded"></div>
            <span className="text-sm font-semibold text-gray-700">Partenaires Qualifiés</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {trades.map((trade, index) => (
            <div 
              key={index} 
              className={`bg-white rounded-2xl p-8 shadow-lg border-2 ${
                trade.color === 'teal' ? 'border-teal-100 hover:border-teal-300' : 'border-orange-100 hover:border-orange-300'
              } hover:shadow-xl transition-all`}
            >
              <div className={`w-14 h-14 flex items-center justify-center ${
                trade.color === 'teal' ? 'bg-teal-100' : 'bg-orange-100'
              } rounded-xl mb-4`}>
                <i className={`${trade.icon} text-2xl ${
                  trade.color === 'teal' ? 'text-teal-600' : 'text-orange-600'
                }`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{trade.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{trade.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-10 shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Coordination Professionnelle</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Notre rôle d'entreprise générale consiste à orchestrer l'intervention de tous les corps de métier de manière fluide et efficace. Nous gérons les plannings, assurons la qualité des travaux et garantissons le respect des délais et du budget.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1 mr-3"></i>
                  <div>
                    <strong className="text-gray-900">Planning Optimisé</strong>
                    <p className="text-gray-600 text-sm mt-1">Coordination des interventions pour éviter les temps morts et les conflits</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1 mr-3"></i>
                  <div>
                    <strong className="text-gray-900">Contrôle Qualité</strong>
                    <p className="text-gray-600 text-sm mt-1">Vérification systématique de la conformité et de la qualité des travaux</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1 mr-3"></i>
                  <div>
                    <strong className="text-gray-900">Gestion Administrative</strong>
                    <p className="text-gray-600 text-sm mt-1">Autorisations, assurances, garanties et documentation complète</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20construction%20project%20manager%20coordinating%20multiple%20trades%20on%20a%20modern%20Swiss%20building%20site%2C%20team%20meeting%20with%20architects%20engineers%20electricians%20and%20contractors%20reviewing%20blueprints%20and%20plans%2C%20organized%20workspace%20with%20safety%20equipment%20and%20professional%20tools%20in%20bright%20natural%20lighting&width=800&height=600&seq=coordination-img&orientation=landscape"
                alt="Coordination des Corps de Métier"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
